import React, { useState, useEffect } from "react";
import HeaderLeft from "./HeaderLeft";
import { Link, useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import GetStorage from "../services/Storage";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import storage from "../services/Storage";
import polygon from "../assets/images/Polygon 56.png";

function AnalystApplication(props) {
  const [analyst, setAnalyst] = useState([]);
  const token = GetStorage.get("xAuthToken");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = GetStorage.get("user");
    if (user.data.is_approved === 0) {
      navigate("/");
    }
    Applicants();
  }, []);

  const Applicants = async () => {
    setLoading(true);

    http
      .get(`api/analyst/assigned-applicants/list?token=${token}`)
      // .get(`api/analyst/not-approved/applicants/list?token=${token}`)
      .then((res) => {
        // setAnalyst(res.data);
        setAnalyst(res.data.getAssignedApplicantDetails);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const ViewBucket = (item) => {
    // console.log("id---->", item);
    storage.store("selectedAnalystName", item.firstname + ' ' + item.lastname);
    navigate(`/analystApplicantJohnDoe/${item.applicant_id}`);
    // navigate(`/analystApplicantJohnDoe/${item.id}`);
  };
  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification mb_40 ">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Analyst Applicants</h1>
          <div class="table_vedio_upload  container mt_40 mb_30 ">
            <table class="table table-borderless table-responsive-lg">
              <thead>
                <tr>
                  <th scope="col" class="font-weight-bold">
                    Video
                  </th>
                  {/* <th scope="col" className="font-weight-bold">
                    Applicant ID
                  </th> */}
                  <th scope="col" className="font-weight-bold">
                    Applicant Name
                  </th>
                  <th scope="col" className="font-weight-bold">
                    Email ID
                  </th>
                  <th scope="col" className="font-weight-bold">
                    Cell Number
                  </th>
                  <th scope="col" className="font-weight-bold">
                    Status
                  </th>
                  <th scope="col" className="font-weight-bold  text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody class="overflow_custom">
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      marginTop: 40,
                      backgroundColor: "#ffffffc2",
                    }}
                  >
                    <SpinnerCircular size="7%" />
                  </div>
                ) : (
                  <>
                    {analyst?.map((item, key) => (
                      <tr>
                        <td className="pl_25">
                          <Link to="/video" state={{ video: item.path }}>
                            <video
                              src={item.path}
                              style={{ width: 120, height: 100 }}
                            />
                            <img
                              src={polygon}
                              alt=""
                              style={{
                                position: "absolute",
                                marginTop: 40,
                                marginLeft: -70,
                                width: 20,
                                height: 20,
                              }}
                            />
                          </Link>
                        </td>
                        {/* <td>{item.id}</td> */}
                        <td>
                          {item.firstname} {item.lastname}
                        </td>
                        <td>{item.email}</td>
                        <td>{item.phone}</td>
                        <td style={{ color: item.is_approved === 1 ? 'green' : item.is_cancelled === 1 ? 'red' : 'orange' }}>{item.is_approved === 1 ? "Approved" : item.is_cancelled === 1 ? "Cancelled" : (item.is_approved === 0 && item.is_cancelled === 0) ? "Pending" : null}</td>
                        <td>
                          <div class="btn_wraper d-flex justify-content-center ">
                            <button
                              type="button"
                              class="them_btn "
                              onClick={() => ViewBucket(item)}
                            >
                              View Bucket
                            </button>
                            {/*  <Link
                              to="/analystApplicantJohnDoe"
                              state={{ id: item.id, name: item.firstname }}
                            >
                              <button type="button" class="them_btn ">
                                View Bucket
                              </button>
                            </Link> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}

export default AnalystApplication;
